import { useSession } from "@/hooks/auth-hooks";
import { useInstantAuth } from "@daveyplate/better-auth-instantdb";
import { instantClientDB } from "instantdb/instantClient";

export function InstantProvider({ children }: { children: React.ReactNode }) {
  const { data: sessionData, isPending } = useSession();

  // Set up InstantDB auth sync with Better Auth
  useInstantAuth({
    db: instantClientDB,
    sessionData,
    isPending,
  });

  return children;
}
